// 实体关联资源模块
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { SwMassageConfirmComponent } from "src/app/librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component";
import { SwModalframeComponent } from "src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component";
import { SwGridTableComponent } from "src/app/librarys/components/basic-components/sw-table/sw-grid-table/sw-grid-table.component";
import { DictionaryService } from "src/app/librarys/serves/public/dictionary.service";
import { SwCreateModalComponentService } from "src/app/librarys/serves/sw-create-modal-component.service";
import { SwJwtService } from "src/app/librarys/serves/sw-jwt.service";
import { SwMassageBoxService } from "src/app/librarys/serves/sw-massage-box.service";
import { environment } from "src/environments/environment";
import { KmsFileUploaderBoxComponent } from "../../components/kms-file-uploader/kms-file-uploader-box/kms-file-uploader-box.component";
import { KmsService } from "../../kms.service";
import { KmsEnum } from "../../serves/kms-enum";
import { ResourcesSelectComponent } from "../../views/knowledge-resources/resources-select/resources-select.component";
import { MaterialViewComponent } from "../../views/material-manage/material-view/material-view.component";
import { InstanceModuleService } from "../../serves/instance/instance.module";
declare var $;
@Component({
  selector: "app-resource-list",
  templateUrl: "./resource-list.component.html",
  styleUrls: ["./resource-list.component.css"],
})
export class ResourceListComponent implements OnInit {
  // 当前所处模块是否为媒体资源
  @Input() tabId: string = "";
  // 默认所属实体名称
  @Input() initInstanceName: string = "";
  // 默认所属实体名称
  @Input() initInstanceId: string = "";
  // 接收父组件的数据：状态
  @Input() state: string = "edit";
  // 表格对象
  @ViewChild("swtable") swtable: SwGridTableComponent;
  // 确认删除弹框
  @ViewChild("trim") trim: SwMassageConfirmComponent;
  // 修改排序号弹框
  @ViewChild('editModal') editModal: SwModalframeComponent;
  // 搜索数据内容
  searchDatas = {
    fileName: "", // 资源名称
    fileCategory: "FILE_TYPE_ALL", // 资源类型
  };
  // 搜索资源类型数据
  fileCategoryOptions = [{ id: "FILE_TYPE_ALL", text: "全部" }];
  fileCategoryOptions1 = [];
  // 资源表格数据
  datas: any = [];
  // 表格是否显示加载中
  isLoading: boolean = false;
  // 表格分页组件
  pageBase: any = { orderBy: null };
  // 表格操作按钮
  toolbar = [
    {
      status: true,
      functionCode: "select",
      functionName: "选择资源",
      icon: "glyphicon glyphicon-folder-open",
      children: [],
    },
    {
      status: true,
      functionCode: "upload",
      functionName: "上传资源",
      icon: "glyphicon glyphicon-plus",
      children: [],
    },
    {
      status: true,
      functionCode: "delete",
      functionName: "批量删除",
      icon: "glyphicon glyphicon-remove",
      children: [],
    }
  ];
  selectedDatas: any = [];
  selectResource:any = {};
  //正整数正则
  integerReg = /^[1-9]\d*$/;
  // 用户角色
  userRole = '';
  typeOptions:any = [];
  // 是否查看大图
  showBigImg = false;
  filePath = '';
  constructor(
    private box: SwMassageBoxService,
    private router: Router,
    private dicService: DictionaryService,
    private create: SwCreateModalComponentService,
    private jwt: SwJwtService,
    private kmsService: KmsService,
    private instanceModuleService: InstanceModuleService
  ) {}

  ngOnInit() {
    // 获取用户角色
    this.userRole = this.jwt.getToken('userRole');
    // 资源类型数据
    this.fileCategoryOptions = this.fileCategoryOptions.concat(
      this.instanceModuleService.getResourceTypeOptions()
    );
    // 把所有外站链接类型的合并成外站链接一个选项
    this.fileCategoryOptions1 = JSON.parse(JSON.stringify(KmsEnum.fileTypes));
    this.fileCategoryOptions1.unshift({ id: "FILE_TYPE_ALL", text: "全部" });
    // 获取图像类型字典
    this.typeOptions = this.dicService.getDictionaryTree(KmsEnum.KGS_IMAGE_TYPE_OPTION,'dictionaryId','dictionaryName','parentId','dictionaryValue');
    let options = JSON.parse(JSON.stringify(this.typeOptions));
    this.typeOptions.forEach(element => {
        let item = options.filter(el => el.id == element['pid']);
        element['pid'] = item.length>0 ? item[0].value : '0';
        element['parentId'] = element['pid'];
        element['id'] = element['value'];
    });
  }

  ngOnChanges() {
    if (this.tabId == "003" && this.initInstanceId) {
      if (this.state == "view") {
        this.toolbar = [];
      } 
      this.handleSelectClick();
    }
  }

  //enter键触发搜索
  enterSearch(event) {
    if (event.keyCode == "13") {
      this.handleSelectClick();
    }
  }

  // 查询按钮方法
  handleSelectClick() {
    this.pageBase = {
      current: 1,
      size: 10,
    };
    this.getData();
  }

  //获取数据
  getData() {
    this.isLoading = true;
    let params = {};
    params = {
      fileName: $.trim(this.searchDatas.fileName),
      fileCategory: this.searchDatas.fileCategory == "FILE_TYPE_ALL" ? "" : this.searchDatas.fileCategory,
      instanceId: this.initInstanceId,
      current: this.pageBase.current,
      size: this.pageBase.size,
    };
    this.kmsService.queryRelatedFileList(params).subscribe((data) => {
      this.isLoading = false;
      if (data.code == "200") {
        this.pageBase = data.data;
        let res = data.data.records ? data.data.records : [];
        this.datas = [];
        res.forEach((item) => {
          const item1 = this.instanceModuleService.getResourceThumbnail(item,this.fileCategoryOptions);
          this.datas.push(item1);
        });
      } else {
        this.box.waring(data.msg);
      }
    });
  }

  // 表格按钮点击事件
  handleOperationClick(event) {
    switch (event) {
      case "select":
        this.selectFiles();
        break; // 从实体资源库中选择
      case "upload":
        this.upload();
        break; // 上传
      case "delete":
        this.handleDeleteClick();
        break; // 批量删除
    }
  }

  /**
   * 工具栏点击事件--选择文件
   * @ignore
   */
  selectFiles() {
    let params = {
      instanceId: this.initInstanceId,
      instanceName: this.initInstanceName,
    };
    this.create.createModal(
      ResourcesSelectComponent,
      params,
      this.selectCallback.bind(this)
    );
  }

  /**
   * 选择完成后的回调
   * @ignore
   */
  selectCallback(data?) {
    this.handleSelectClick();
  }

  /**
   * 工具栏点击事件--上传文件
   * @ignore
   */
  upload() {
    // 通过知识库标识拼接文件策略
    let kgDbInfo = JSON.parse(this.jwt.getToken("kgDbInfo"));
    let kgCode = kgDbInfo && kgDbInfo.englishCode ? kgDbInfo.englishCode : "";
    let fileCode = kgCode
      ? KmsEnum.KMS_INSTANCE_RESOURCE + "_" + kgCode.toUpperCase()
      : "";

    let uploadParams = {
      label3: "filePicker", //根据 label3 确定上传组件的 id
      fileCode: fileCode, //根据 fileCode 查询策略
      fileBusinessId: "", //根据 fileCode 和 fileBusinessId 查询已上传文件,如果此值为空，就根据下面的 fileInfoIds 来查
      fileInfoIds: [], //根据 fileInfoIds 也可以查询已上传文件
      closeDisabled: true, //根据此值决定上传模态框中右上角的 × 是否消失
      isUploadResource: true  //是否上传资源
    };
    this.create.createModal(
      KmsFileUploaderBoxComponent,
      uploadParams,
      this.uploadCallback.bind(this)
    );
  }

  /**
   * 上传完成后的回调
   * @ignore
   */
  uploadCallback(event) {
    // event.addList 需保存的资源信息； event.instanceInfo 需关联的实体信息
    let files = event.list.addList;
    let resourceParams = event.resourceParams;
    if (files) {
      let params = [];
      files.forEach((element) => {
        let thumbnailPath = "";
        if (element.fileType == "FILE_TYPE_PICTURE") {
          let index = element.fileName.lastIndexOf(".");
          let name =
            element.fileName.substring(0, index) +
            "_300@x." +
            element.fileSuffix;
          thumbnailPath = element.filePath + "THUMB/" + name;
        }
        let arr = element.fileOldname.split(".");
        let fileName = "";
        for (let i = 0; i < arr.length - 1; i++) {
          if (i == arr.length - 2) {
            fileName += arr[i];
          } else {
            fileName += arr[i] + ".";
          }
        }
        let category = this.isNotTiff(element.fileName)
          ? element.fileType
          : "FILE_TYPE_PICTURE";
        let entity = {
          fileId: element.fileInfoId,
          fileSuffix: element.fileSuffix,
          materialTitle: fileName,
          filePath: element.filePath + element.fileName,
          materialCategory: category,
          fileThumbnail: thumbnailPath,
          accessType: 1,
          approvalStatus: 0,
          currentUserRole: this.userRole == '知识编辑' ? 1 : 2,
          status: 0,
          textExtractStatus: 0,
          catalogId: resourceParams.catalogId,
          docType: resourceParams.docType,
        };
        params.push(entity);
      });
      // 保存资源信息
      this.kmsService.saveOrUpdateMaterial(params).subscribe((data) => {
        if (data.code == "200") {
          this.updateESMaterialInfo(data.data);
          // 保存关联关系
          let params1 = [];
          data.data.forEach((el) => {
            let entity1 = {
              associatedType: 1,
              fileInfoId: el,
              sourceId: this.initInstanceId,
            };
            params1.push(entity1);
          });
          this.kmsService.saveFileRelationship(params1).subscribe((data) => {
            if (data.code == "200") {
              this.box.success("保存成功！");
              this.getData();
            } else {
              this.box.waring(data.msg);
            }
          });
        } else {
          this.box.waring(data.msg);
        }
      });
    }
  }

  // 更新资源es信息
  updateESMaterialInfo(ids){
    if(ids.length == 0){
      return;
    }
    this.kmsService.updateESMaterialInfo({"materialIdList":ids}).subscribe(
      data => {
        if (data["code"] != 200) {
          this.box.danger(data.msg);
        }
      }
    )
  }

  // 获取文件类型名称
  getCategoryName(id,code) {
    let items = this.fileCategoryOptions1.filter((item) => item.id == id);
    if(items.length>0){
      return items[0].text == '图片' ? this.getImageTypeName(code) : items[0].text;
    }else{
      return '其他';
    }
  }

  // 根据标识获取图像类型名称
  getImageTypeName(code){
    if(!code){
        return '图片';
    }
    let items = this.typeOptions.filter(el => el.id == code);
    if(items.length>0){
        return '图片（'+items[0].text+'）';
    }else{
        return '图片';
    }
  }

  // 批量删除
  handleDeleteClick() {
    if (this.selectedDatas.length == 0) {
      this.box.danger("请至少选择一条数据！");
      return;
    }
    let ids = [];
    this.selectedDatas.forEach((item) => {
      ids.push(item.fileRelationshipId);
    });
    this.delete(ids);
  }

  /**
   * 点击td中的按钮
   * @ignore
   */
  clickTdBtn(type, data) {
    //禁止冒泡
    event.stopPropagation();
    // 查看
    if (type == "view") {
      let param = { "upOrAdd": "View", "selectedData": data };
      this.create.createModal(MaterialViewComponent, param, this.getData.bind(this));
    }
    // 单条编辑
    else if (type == "edit") {
      this.selectResource  = JSON.parse(JSON.stringify(data));
      this.editModal.toggle();
    }
    // 单条删除
    else if (type == "delete") {
      this.delete([data.fileRelationshipId]);
    }
    // 图像标记
    else if (type == "mark") {
      // data["mode"] = this.state;
      // this.router.navigate(["/kms/ResourcesMark"], {
      //   queryParams: { Title: "图像标记", selectedData: JSON.stringify(data) },
      // });
      data["mode"] = 'view';
      this.router.navigate(["/kms/ResourcesMark"], {
        queryParams: { Title: "查看图像标记", selectedData: JSON.stringify(data) },
      });
    }
  }

  // 表格选中数据
  handleSelectData(event) {
    this.selectedDatas = event;
    //设置表格按钮组状态
    this.swtable.toolbarAllEnable();
    if (this.selectedDatas.length == 0) {
      this.swtable.toolbarDisable("edit");
      this.swtable.toolbarDisable("delete");
    }
  }

  // 表格分页切换方法
  handlePageClick(event) {
    this.pageBase = event;
    this.getData();
  }

  // 重置按钮事件方法
  handleReloadClick() {
    this.searchDatas = {
      fileName: "",
      fileCategory: "FILE_TYPE_ALL",
    };
    this.pageBase = {
      current: 1,
      size: 10,
    };
    this.getData();
  }

  // 点击删除
  delete(ids) {
    this.trim.openCLick("确认删除吗？", (data) => {
      if (data) {
        this.kmsService.deleteRelatedFileById(ids).subscribe((data) => {
          if (data["code"] == "200") {
            this.box.success("操作成功");
            this.getData();
          } else {
            this.box.waring(data.msg);
          }
        });
      }
    });
  }

  isNotTiff(path) {
    if (path && (path.indexOf(".tif") >= 0 || path.indexOf(".tiff") >= 0)) {
      return false;
    } else {
      return true;
    }
  }

  // 保存排序号
  sure() {
    if (
      ($.trim(this.selectResource.sortNum) && this.integerReg.test(this.selectResource.sortNum)) ||
      !this.selectResource.sortNum ||
      this.selectResource.sortNum == ""
    ) {
      // 重命名
      const params1 = {
        materialId: this.selectResource.materialId,
        materialTitle: this.selectResource.materialTitle,
        type: this.selectResource.type
      }
      this.kmsService.saveMaterialInfo(params1).subscribe(
        data => {
          if(data.code != '200'){
            this.box.waring('素材信息保存失败！');
          }else{
            this.updateESMaterialInfo([this.selectResource.materialId]);
          }
        }
      );

      // 保存排序号
      const params = {
        fileRelationshipId: this.selectResource.fileRelationshipId,
        sourceId: this.initInstanceId,
        sortNum: this.selectResource.sortNum
      };
      this.kmsService.saveFileRelationshipById(params).subscribe((data) => {
        if (data.code == "200") {
          this.box.success("保存成功！");
          this.editModal.toggle();
          this.getData();
        } else {
          this.box.waring(data.msg);
        }
      });
    } else {
      this.box.danger("排序号必须为大于零的整数！");
    }
  }

  // 取消操作
  cancel() {
    this.editModal.toggle();
  }

  // 选择资源类型
  selectCategory(item){
    this.searchDatas.fileCategory = item.id;
    this.handleSelectClick();
  }

  // 查看大图
  viewBigImg(data){
    // 图片
    if (data.materialCategory == 'FILE_TYPE_PICTURE'){
      this.showBigImg = true;
      this.filePath = data.filePath;
    }else{
      this.box.info('很抱歉，当前文件不支持预览！');
    }
  }
}


